import { render, staticRenderFns } from "./Demarcheurs.vue?vue&type=template&id=5ac4b853&"
import script from "./Demarcheurs.vue?vue&type=script&lang=js&"
export * from "./Demarcheurs.vue?vue&type=script&lang=js&"
import style0 from "./Demarcheurs.vue?vue&type=style&index=0&id=5ac4b853&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports